import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetFilters } from 'redux/slices/icalendarFilterSlice';

/**
 * Custom hook to reset filters when the path changes
 * @param {string} componentName - Name of the component using this hook (for debugging)
 * @param {function} resetAction - Redux action to dispatch for resetting filters
 */
export const usePathBasedReset = (componentName = 'Component', resetAction = resetFilters) => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        const globalKey = `previousPath_${componentName}`;
        const previousPath = window[globalKey];

        // Only reset if we're not on the initial load and the path actually changed
        if (previousPath && previousPath !== currentPath) {
            dispatch(resetAction());
        }

        // Store current path globally for next comparison
        window[globalKey] = currentPath;
    }, [dispatch, location.pathname, componentName, resetAction]);
};

export default usePathBasedReset;
